import { Link as RouterLink } from "react-router-dom"

export default function Link({ children, href = "", className = "" }) {
    const baseStyle = "font-body text-sm font-medium tracking-wide text-slate-400 transition-all duration-300 ease-in-out hover:text-cyan-400 hover:drop-shadow-[0_0_8px_rgba(34,211,238,0.8)]"

    if (href.startsWith("#")) {
        return (
            <a href={href} className={`${baseStyle} ${className}`}>
                {children}
            </a>
        );
    }

    return (
        <RouterLink className={`${baseStyle} ${className}`} to={href}>
            {children}
        </RouterLink>
    )
}